<template>
  <el-collapse v-model="layoutTemplate.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="search-section" id="search-section">
      <el-form
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.dayOfWeek')" prop="day">
              <el-select
                v-model="searchForm.day"
                id="searchForm-day"
                ref="filter-day"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in daysOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.code')" prop="code">
              <el-input
                v-model="searchForm.code"
                ref="filter-code"
                v-numeric-validation
                maxlength="25"
                clearable
                @clear="handleSearch"
                v-on:keyup.enter.native="handleSearch"
                class="inline-input"
                id="searchForm-code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layoutTemplate.name')" prop="name">
              <el-input
                v-model="searchForm.name"
                ref="filter-name"
                v-alphanumeric-validation
                maxlength="50"
                clearable
                @clear="handleSearch"
                v-on:keyup.enter.native="handleSearch"
                class="inline-input"
                id="searchForm-name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('common.search')"
              placement="top-start"
            >
              <el-button
                id="form-search-button"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
                class="button-action-default"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'SearchFilters',
  computed: {
    ...mapGetters(['layoutTemplate'])
  },
  data() {
    return {
      searchForm: {
        day: null,
        code: null,
        name: null
      },
      activeCollapsibleName: ['search-section'],
      daysOptions: constants.DAYS_OPTIONS
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('layoutTemplate/search', this.searchForm);
    }
  }
};
</script>
